var czekanowskiD = require('./../distances/czekanowski');

module.exports = function czekanowski(a, b) {
    return 1 - czekanowskiD(a,b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/czekanowski.js
 ** module id = 81
 ** module chunks = 0
 **/